const API_EXCEPTIONS = {
  FWC_TOKEN_EXCEPTION: "FwcTokenException",
  UNAUTHORIZED: "Unauthorized",
  UNKNOWN_EXCEPTION: "UnknownException",
};

export { API_EXCEPTIONS };
